import { render, staticRenderFns } from "./definition-de-lomnicanal.vue?vue&type=template&id=3b90fb10&"
import script from "./definition-de-lomnicanal.vue?vue&type=script&lang=js&"
export * from "./definition-de-lomnicanal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports